module.exports = __webpack_public_path__ + "static/media/lablogo.014f8cb6.png";